import { lazy } from "react";

export const NewWordPage = lazy(() => import("./ui/NewWordPage"));
